import { c as _c } from "react/compiler-runtime";
// Карточка промокода — «билет» из ленты промокодов корзины (Figma «5.
// Корзина», кадры 4140:45301, 4141:45676, 4140:45362).
//
// Билет 238×86: градиент слева направо (четыре палитры по очереди, как в
// макете), вогнутые углы, справа отрывной корешок 38 с белой пунктирной
// линией и вертикальной надписью «Применить». Внутри — НАЗВАНИЕ 12/16 w600
// капсом с разрядкой 1, крупно «-20%» 20/23 w600, «до 31 октября» 12/16.
// Под билетом — условие 12/16 в две строки.
//
// Тексты (название, скидка, срок, условия) собирает шлюз — одинаково для
// веба и приложения, клиент их не выдумывает.

import type { BuyerCoupon } from "@/api";
import { cn } from "@/lib/utils";

/** Палитры билетов из макета: оливковая, розовая, коралловая, голубая. */
const PALETTES = ["linear-gradient(90deg, #BCBC82 0%, #EDEDDE 100%)", "linear-gradient(90deg, #FFC5D3 0%, #FFF1F5 100%)", "linear-gradient(90deg, #E2725B 0%, #F7DBD6 100%)", "linear-gradient(90deg, #96BAE0 0%, #E0EBF6 100%)"];

// Вогнутые углы билета: четыре радиальных выреза маской.
const NOTCH = 10;
const ticketMask = [`radial-gradient(${NOTCH}px at 0 0, #0000 98%, #000) 0 0 / 51% 51% no-repeat`, `radial-gradient(${NOTCH}px at 100% 0, #0000 98%, #000) 100% 0 / 51% 51% no-repeat`, `radial-gradient(${NOTCH}px at 0 100%, #0000 98%, #000) 0 100% / 51% 51% no-repeat`, `radial-gradient(${NOTCH}px at 100% 100%, #0000 98%, #000) 100% 100% / 51% 51% no-repeat`].join(", ");
export type PromoTicketProps = {
  coupon: Pick<BuyerCoupon, "code" | "title" | "headline" | "expiresLabel" | "conditions">;
  /** Номер карточки в ленте — выбирает палитру. */
  index: number;
  /** Корешок: «Применить» / «Применён». Нет — корешок без надписи. */
  action?: {
    label: string;
    onClick?: () => void;
    disabled?: boolean;
    pending?: boolean;
  };
  /** Пояснение под условиями (почему не применится сейчас). */
  note?: string | null;
  /** Закончившийся код — приглушён. */
  muted?: boolean;
  className?: string;
  /** Дополнительные элементы под условиями (код, «Убрать»). */
  children?: React.ReactNode;
};
export function PromoTicket(t0) {
  const $ = _c(36);
  const {
    coupon,
    index,
    action,
    note,
    muted,
    className,
    children
  } = t0;
  const conditions = coupon.conditions.length > 0 ? `${coupon.conditions.map(_temp).join(". ")}.` : null;
  const longHeadline = coupon.headline.length > 12;
  const t1 = muted && "opacity-55 grayscale";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = cn("flex w-[238px] shrink-0 flex-col gap-2", t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `promo-ticket-${coupon.code}`;
  const t4 = PALETTES[index % PALETTES.length];
  let t5;
  if ($[3] !== t4) {
    t5 = {
      background: t4,
      mask: ticketMask,
      WebkitMask: ticketMask
    };
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== coupon.title) {
    t6 = <p className="truncate text-[12px] leading-4 font-semibold tracking-[1px] uppercase" title={coupon.title}>{coupon.title}</p>;
    $[5] = coupon.title;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = longHeadline ? "text-[16px] leading-[23px]" : "text-[20px] leading-[23px]";
  let t8;
  if ($[7] !== t7) {
    t8 = cn("truncate font-semibold tracking-[-0.31px]", t7);
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== coupon.headline || $[10] !== t8) {
    t9 = <p className={t8}>{coupon.headline}</p>;
    $[9] = coupon.headline;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const t10 = coupon.expiresLabel ?? "\u0411\u0435\u0441\u0441\u0440\u043E\u0447\u043D\u043E";
  let t11;
  if ($[12] !== t10) {
    t11 = <p className="truncate text-[12px] leading-4">{t10}</p>;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11 || $[15] !== t6 || $[16] !== t9) {
    t12 = <div className="flex min-w-0 flex-1 flex-col justify-center gap-0.5 py-2.5 pr-2 pl-5">{t6}{t9}{t11}</div>;
    $[14] = t11;
    $[15] = t6;
    $[16] = t9;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== action || $[19] !== coupon.code) {
    t13 = action ? <button type="button" onClick={action.onClick} disabled={action.disabled || action.pending} aria-label={`${action.label}: ${coupon.code}`} data-testid={`promo-ticket-apply-${coupon.code}`} className="flex w-[38px] shrink-0 items-center justify-center border-l border-dashed border-white text-[12px] leading-4 font-semibold outline-none transition-colors hover:bg-white/25 focus-visible:bg-white/35 disabled:cursor-default disabled:hover:bg-transparent"><span className="[writing-mode:vertical-rl]">{action.pending ? "\u2026" : action.label}</span></button> : <span className="w-[38px] shrink-0 border-l border-dashed border-white" aria-hidden={true} />;
    $[18] = action;
    $[19] = coupon.code;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t12 || $[22] !== t13 || $[23] !== t5) {
    t14 = <div className="flex h-[86px] w-full overflow-hidden text-black" style={t5}>{t12}{t13}</div>;
    $[21] = t12;
    $[22] = t13;
    $[23] = t5;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== conditions) {
    t15 = conditions && <p className="line-clamp-2 text-[12px] leading-4 text-black">{conditions}</p>;
    $[25] = conditions;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== note) {
    t16 = note && <p className="text-[12px] leading-4 text-[#FA5C2E]">{note}</p>;
    $[27] = note;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== children || $[30] !== t14 || $[31] !== t15 || $[32] !== t16 || $[33] !== t2 || $[34] !== t3) {
    t17 = <div className={t2} data-testid={t3}>{t14}{t15}{t16}{children}</div>;
    $[29] = children;
    $[30] = t14;
    $[31] = t15;
    $[32] = t16;
    $[33] = t2;
    $[34] = t3;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  return t17;
}
function _temp(c) {
  return c.replace(/\.$/, "");
}